import React from "react";
import ContractEnergyDTO from "features/contracts/dtos/ContractEnergyDTO";
import ContractFullDTO from "features/contracts/dtos/ContractFullDTO";
import ContractDetailLayoutPage from "./ContractDetailLayoutPage";
import ContractDocumentsSection from "features/contracts/sections/ContractDocumentsSection";
import { useTranslation } from "react-i18next";


interface Props {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const ContractDocumentsPage = ({ contract, contractEnergy }: Props) => {
  // translations
  const tLabels = useTranslation(["shared\\moduleNames"]).t;

  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[{ text: tLabels("contractDocumentsPage.title") }]}
    >
      <ContractDocumentsSection
        contractId={contract.contractId!}
      />
    </ContractDetailLayoutPage>
  );
}

export default ContractDocumentsPage